<template>
  <div id="footer">
    <!-- <div class="px1200">
      <div class="bottom1"> <img src="http://www.gsmtjyzx.com/bootstrap/img/GH.png" style="width:13px" alt=""> 甘公网安备 62010202001483号 版权所有 陇ICP备20000113号</div>
      <div class="bottom2">Copyright@2020 GCTC · GanSu Coal Trading Center.All Rights Reserved</div>
    </div> -->
    <div class="bg03">
      <!-- <div class="wrapper">
        <el-row>
          <el-col :span="8" style="text-align: start;">
            <img src="../assets/bottom_logo.png" class="fl" alt=""/>
          </el-col>
          <el-col :span="8" style="text-align: center;">
            <div class="footer02 fl" style="text-align: start; padding-left: 80px;" v-html="contentList.length>0?contentList[0].aboutContent:null">
            </div>
          </el-col>
          <el-col :span="8">
            <img src="../assets/erweima.png" class="fr" alt="" />
          </el-col>
        </el-row>
      </div> -->
      <div class="wrapper">
            <div class="bottom_logo fl">
                <img src="../assets/bottom_logo.png" alt=""> <br>
                <p><img src="https://gsmtjyzx.com/ctp-web/bootstrap/img/GH.png" width="13" class="m-r-xs">甘公网安备 62010202001483号</p>
                <p><a href="https://beian.miit.gov.cn/" target="_blank">陇ICP备20000113号</a> </p>
                <p>版权所有：甘肃煤炭交易中心</p>
                
                
            </div>
            
            <div class="footer02 fl">
                <div class="t">
                    客服热线
                </div>
                <div class="con" v-html="contentList.length>0?contentList[0].aboutContent:null">
                    <!-- 0931-8581620 <br>
                    [周一至周五9:30-16:00] <br>
                    客服邮箱：GNHTJT@qq.com <br>
                    CA客服专线：0931-4267890 <br>
                    CA客服QQ群：1125403345 -->
                </div>
            </div>
            <div class="footer02 fl">
                <div class="t">
                    网站导航
                </div>
                <div class="con">
                    <a @click="handleNewPage('ZXDT')">中心动态</a>
                    <a @click="handleNewPage('XWZX')">新闻资讯</a>
                    <a @click="handleNewPage('QYWH')">企业文化</a>
                    <a @click="handleNewPage('DDJS')">党的建设</a>
                    <a @click="handleNewPage('GYWM')">关于我们</a>
                </div>
            </div>
            <div class="footer03 fl">
                <div class="t">
                    关注我们
                </div>
                <div class="con">
                    <img src="../assets/erweima.png" alt="">
                </div>
            </div>
            
            <div class="cb"></div>
        </div>
    </div>
    <!-- <div class="bg04">
      <div class="footer">
        <span style="padding-right: 30px">版权所有：甘肃煤炭交易中心</span>
        <span>陇ICP备20000113号</span>
      </div>
    </div> -->
    <div class="erweima">
        <img src="../assets/erweima01.png" alt="">
    </div>
  </div> 
</template>

<script>
export default {
  name: "Footer",
  components: {},
  created() {},
  mounted() {
    this._getAbout();
  },

  data() {
    return {
      currentPage: 1,
      totalNum: 0,
      contentList: []
    };
  },
  methods: {
    handleSizeChange() {},
    handleCurrentChange() {},
    handleNewPage(val){
      let path = "";
      if(val=='ZXDT'){
        path = "/gctc-portalsite/newsCenter?value=ZXYW"
      }else if(val=='XWZX'){
        path = "/gctc-portalsite/counsel?value=SZYW"
      }else if(val=='QYWH'){
        path = "/gctc-portalsite/business?value=QYLN"
      }else if(val=='DDJS'){
        path = "/gctc-portalsite/party?value=DJDT"
      }else if(val=='GYWM'){
        path = "/gctc-portalsite/about?value=QYJS"
      }
      const { href } = this.$router.resolve({
        //path是要跳转到的页面路径
        path: path
      });
      //结合open打开新的页面
      window.open(href, "_blank");
    },
    _getAbout() {
      let data = {
        pageSize: 15,
        pageNumber: 1,
        aboutKind: 'LXWM',
        aboutMenu: 'GYWM'
      };
      this.$post(
        this.$store.state.CTP_BASE + "/portalAbout/getPortalAboutPage",
        data
      ).then((res) => {
        if (res.status == "0") {
          this.contentList = res.data.dataList
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../style/global-style.css";
.bottom_logo a{
  color: #757575;
}
.bottom_logo{
  line-height: 30px;
}
// #footer {
//   width: 100%;
//   height: 80px;
//   // background: red;
//   padding: 21px 0;
//   // text-align: center;
//   .bottom1 {
//     margin-bottom: 7px;
//   }
// }
// .bg03 {
//   background: #1f1f1f;
//   padding-bottom: 20px;
// }
// .wrapper {
//   width: 1200px;
//   margin: 0 auto;
// }
// .footer02 {
//   width: 278px;
//   padding-top: 30px;
//   font-size: 14px;
//   color: #fff;
//   line-height: 24px;
//   // margin-left: 180px;
// }
// .footer02 .t {
// 	padding-left: 40px;
// 	font-size: 16px;
// 	margin-bottom: 15px;
//   text-align: start;
// }
// .con{
//   text-align: start;
//   padding-left: 40px;
// }
// .bg04 {
// 	background: #023563;
// }
// .footer {
// 	color: #fff;
// 	line-height: 40px;
// 	text-align: center;
// }
// .erweima{
// 	width: 150px;
// 	position: fixed;
// 	right: 10px;
// 	bottom: 30px;
// 	z-index: 999;
// }
// .erweima img{
// 	width: 150px;
// }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue